import { client, urlFor, getSanityEditLink } from "./sanity-client";
import initScrollAnimations from "./animations";

document.addEventListener("DOMContentLoaded", async () => {
  const heroSection = document.getElementById("culture-hero-section");
  if (!heroSection) return;

  try {
    const query = `*[_type == "culture"][0]{
            ...,
            showHero,
            showPerks,
            perks[]{
                ...,
                _key
            }
        }`;
    const data = await client.fetch(query);

    if (!data) {
      console.error("Culture data not found");
      return;
    }

    // 1. Render Hero Section
    if (data.showHero === false) {
      if (heroSection) heroSection.style.display = 'none';
    } else {
      const heroTitleEl = document.getElementById("culture-hero-title");
      const heroDescEl = document.getElementById("culture-hero-desc");

      if (heroTitleEl) {
        if (data._id) {
          heroTitleEl.parentElement.classList.add('position-relative');
          heroTitleEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'culture', 'pageTitle', 'Edit Hero'));
        }
        heroTitleEl.textContent = data.pageTitle;
      }
      if (heroDescEl) heroDescEl.textContent = data.heroDescription;
    }

    // Perks toggle
    if (data.showPerks === false) {
      const offerTitleEl = document.getElementById("culture-offer-title");
      const perksListContainer = document.getElementById("culture-perks-list");
      const perksCardsContainer = document.getElementById("culture-perks-cards");
      if (offerTitleEl) offerTitleEl.closest('section').style.display = 'none';
      if (perksListContainer) perksListContainer.closest('section').style.display = 'none';
      if (perksCardsContainer) perksCardsContainer.closest('section').style.display = 'none';
    } else {
      // 2. Render Offer Title
      const offerTitleEl = document.getElementById("culture-offer-title");
      if (offerTitleEl && data.offerTitle) {
        if (data._id) {
          offerTitleEl.parentElement.classList.add('position-relative');
          offerTitleEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'culture', 'offerTitle', 'Edit Secondary Title'));
        }
        offerTitleEl.textContent = data.offerTitle;
      }

      // 3. Render Perks List (Top Section)
      const perksListContainer = document.getElementById("culture-perks-list");
      if (perksListContainer && data.perks) {
        renderPerksList(perksListContainer, data.perks, data._id);
      }

      // 4. Render Perks Cards (Bottom Section)
      const perksCardsContainer = document.getElementById("culture-perks-cards");
      if (perksCardsContainer && data.perks) {
        perksCardsContainer.innerHTML = data.perks.map((perk, index) => createPerkCard(perk, index, data._id)).join('');
      }
    }

    // Re-initialize animations after content injection
    initScrollAnimations();

  } catch (error) {
    console.error("Error fetching culture data:", error);
  }
});

function renderPerksList(container, perks, docId) {
  const itemsHtml = perks.map((perk, index) => `
        <div class="d-inline-flex align-items-center mx-4 my-2 position-relative" data-animate="fade-up" data-delay="${index * 50}">
            <div class="badge badge-rounded-circle bg-primary-soft me-3 p-2">
                <i class="fe fe-check text-primary"></i>
            </div>
            <p class="text-dark fw-600 mb-0">${perk.title}</p>
        </div>
    `).join('');

  container.innerHTML = `
        <div class="position-relative">
            ${docId ? getSanityEditLink(docId, 'culture', 'perks', 'Edit Perks List') : ''}
            <div class="d-flex flex-wrap justify-content-center pt-3">${itemsHtml}</div>
        </div>
    `;
}

function createPerkCard(perk, index, docId) {
  const isEven = index % 2 === 0;
  const imageUrl = perk.image ? urlFor(perk.image).width(600).url() : '';

  const orderImage = isEven ? 'order-md-2' : 'order-md-1';
  const orderText = isEven ? 'order-md-1' : 'order-md-2';

  return `
    <div class="col-12 col-md-12 px-0" data-animate="fade-up">
          <div class="card card-row shadow-light-lg mb-8 lift border-0 overflow-hidden">
            ${docId && perk._key ? getSanityEditLink(docId, 'culture', `perks[_key=="${perk._key}"]`, 'Edit Perk Card') : ''}
            <div class="row gx-0 align-items-center">
              <div class="col-12 col-md-6 ${orderImage} bg-cover" style="
                    background-image: url(${imageUrl});
                    min-height: 400px;
                  ">
                 <img src="${imageUrl}" alt="${perk.title}" class="img-fluid d-md-none invisible" />
              </div>
              <div class="col-12 col-md-6 ${orderText}">
                <!-- Body -->
                <div class="card-body p-8 p-lg-10">
                  <!-- Heading -->
                  <h4 class="fw-bold mb-4 text-dark display-4">${perk.title}</h4>

                  <!-- Text -->
                  <p class="mb-0 text-muted fs-lg lh-base">
                    ${perk.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    `;
}
